module.exports = __webpack_public_path__ + "img/deleteCol.1d9c7ece.png";